import type { AxiosError } from "axios";
import Axios from "axios";
import { useTranslation } from "react-i18next";
import React, { useContext, useState } from "react";
import type { AssetsExternalLinks } from "../../../../../types/types.PIM";
import { Notifications } from "../../../../../components/Notifications/NotificationsContext";
import { isAxiosError, useStoreState } from "../../../../../util/util";
import { endpoints } from "../../../../../endpoints";
import { EditDeleteModal } from "../../../../../components/EditDeleteModal/EditDeleteModal";

export const DeleteExternalLink = ({
  show,
  onClose,
  onSuccess,
  refreshAssetsList,
  deleteData,
}: {
  onSuccess: () => void;
  refreshAssetsList: any;
  show: boolean;
  onClose: () => void;
  deleteData: AssetsExternalLinks;
}) => {
  const { t } = useTranslation();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const { notifySuccess, notifyError } = useContext(Notifications);

  const { tenant_id } = useStoreState();

  const { id } = deleteData;

  const onDelete = async (): Promise<void> => {
    setIsSubmitting(true);
    try {
      await Axios.delete(
        endpoints.v2_storefronts_id_pim_assets_external_links_id(tenant_id, id)
      );
      await refreshAssetsList();
      notifySuccess(t("Exteranl link successfully Removed"));
      setIsSubmitting(false);
      onSuccess();
    } catch (error) {
      if (
        isAxiosError(error) &&
        (error as AxiosError)?.response?.data?.message
      ) {
        notifyError(error?.response?.data?.message);
      } else {
        notifyError(t("could not delete link, Something went wrong."));
      }
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <EditDeleteModal
        title={t("Delete Link")}
        show={show}
        onClose={onClose}
        onConfirm={onDelete}
        isLoading={isSubmitting}
        body={t("Are you sure you want to delete this external link?")}
        confirmBtnLabel={t("Delete")}
      />
    </>
  );
};
